export function slugify(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function buildProductPath(product) {
  const productId = product?.product_id || product?.id || '';
  const slug = slugify(product?.name);

  return slug ? `/products/${productId}/${slug}` : `/products/${productId}`;
}
